module.exports = __webpack_public_path__ + "img/GTE.94126600.svg";